import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
// import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from '@tanstack/react-query';

import { fetchAll, fetchOne } from '../../lib/v31lib';
import { loginAtom } from '../../lib/auth';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import { Line, CartesianGrid, XAxis, YAxis, Bar, ComposedChart, Tooltip, TooltipProps, PieChart, Pie, Cell, Legend, BarChart, LineChart } from 'recharts';
import {
  ValueType,
  NameType,
} from 'recharts/types/component/DefaultTooltipContent';


import {
  Button as Btn,
  ButtonGroup,
  CircularProgress,
  Divider,
  Grid,
} from '@mui/material';
import {
  ChevronLeft,
  ChevronRight
} from '@mui/icons-material';

import {
  Page,
  StyledButton,
  StyledTextField,
  Typography
} from '../../components/interface';

import {
  BookYear
} from '../../models';

const { DateTime } = require("luxon");

type Props = {};
type RawExportStat = {
  custom_result: any
};

export const OperationsTransfers: FunctionComponent<Props> = () => {
  // const navigate = useNavigate();
  const theme = useTheme();
  
  const [login, setLogin] = useAtom(loginAtom);
  const [statMode, setStatMode] = useState<string>("month");
  const [ageGroups, setAgeGroups] = useState<[number, number][]>([
    [0, 9], [10, 19], [20, 29],
    [30, 39], [40, 49], [50, 59],
    [60, 69], [70, 79], [80, 89],
    [90, 99], [100, 150]
  ]);
  const [perAge, setPerAge] = useState<boolean>(false);
  const [showTimeoutError, setShowTimeoutError] = useState<boolean>(false);
  const [activeMonth, setActiveMonth] = useState<string>(DateTime.now().toFormat("LL/yyyy"));
  const [mainResult, setMainResult] = useState<any>();
  const [activeIteration, setActiveIteration] = useState<number>(0);
  const [showRawData, setShowRawData] = useState<boolean>(false);
  const [graphFocus, setGraphFocus] = useState<string>("age");
  const [ageFocusedLineData, setAgeFocusedLineData] = useState<any>();
  const [ageFocusedLineDataSold, setAgeFocusedLineDataSold] = useState<any>();
  const [amountFocusedBarData, setAmountFocusedBarData] = useState<any>();
  const [colors14, setColors14] = useState<string[]>([ // months and quarters
    "#1B3A57", "#1F4E79", "#2E6F95", "#3F88A8", "#4DA3B3", 
    "#5FB9A6", "#7CCB8F", "#A4D86F", "#CDE05A", "#F0D64E", 
    "#F9B73C", "#F68B2C", "#E85D2A", "#D62828"
  ]);
  const [colors6, setColors6] = useState<string[]>([ // years
    "#1F4E79", "#3F88A8", "#7CCB8F", "#CDE05A", "#F9B73C", "#D62828"
  ]);
  const [colors12, setColors12] = useState<string[]>([ // age groups
    "#2ECC71", "#58D68D", "#82E0AA", "#A9DFBF", "#F4D03F",
    "#F5B041", "#EB984E", "#DC7633", "#CA6F1E", "#A04000",
    "#5D6D7E", "#2C3E50"
  ]);
  const [colors120, setColors120] = useState<string[]>([ // ages
    "#2ECC71","#30CD72","#33CE73","#35CF74","#38D075","#3AD176","#3DD277","#3FD378","#42D479","#44D57A",
    "#47D67B","#49D77C","#4CD87D","#4EDA7F","#51DB80","#53DC81","#56DD82","#58DE83","#5BDF84","#5DE085",
    "#60E186","#63E287","#66E388","#69E489","#6CE58A","#6FE68B","#72E78C","#75E88D","#78E98E","#7BEA8F",
    "#7EEB90","#81EC91","#84ED92","#87EE93","#8AEF94","#8DF095","#90F196","#93F297","#96F398","#99F499",
    "#9CF59A","#A0F49A","#A4F299","#A8F098","#ACEE97","#B0EC96","#B4EA95","#B8E894","#BCE693","#C0E492",
    "#C4E291","#C8E090","#CCDE8F","#D0DC8E","#D4DA8D","#D8D88C","#DCD68B","#E0D48A","#E4D289","#E8D088",
    "#ECD087","#EFCB84","#F2C681","#F5C17E","#F8BC7B","#FBB778","#FDB275","#F8AD72","#F3A86F","#EEA36C",
    "#E99E69","#E49966","#DF9463","#DA8F60","#D58A5D","#D0855A","#CB8057","#C67B54","#C17651","#BC714E",
    "#B76C4B","#B26748","#AD6245","#A85D42","#A3583F","#9E533C","#994E39","#944936","#8F4433","#8A3F30",
    "#853A2D","#80352A","#7B3027","#762B24","#712621","#6C211E","#671C1B","#621718","#5D1215","#580D12",
    "#560F1A","#541122","#52132A","#501532","#4E173A","#4C1942","#4A1B4A","#481D52","#461F5A","#442162",
    "#42236A","#402572","#3E277A","#3C2982","#3A2B8A","#382D92","#362F9A","#3431A2","#3233AA","#2C3E50"
  ]);
  const [hiddenDataPoints, setHiddenDataPoints] = useState<string[]>([]);

  // const {
  //   data: bookYears,
  //   // isLoading: bookYearsLoading,
  //   // isError: bookYearsError,
  //   // isSuccess: bookYearsSuccess,
  //   // refetch: bookYearsRefetch,
  // } = useQuery({
  //   queryKey: ["book_years"],
  //   queryFn: () =>
  //     fetchAll<BookYear>(
  //       "/nl/v3/objects/fetch_all",
  //       {
  //         object: "book_year",
  //         fields: ["id", "short_visual"],
  //         order: "id DESC"
  //       },
  //       login
  //     ),
  //   enabled: !!login
  // });










  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetchOne<{
        custom_result: any
      }>(
        '/nl/v3/objects/custom_action',
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      mutationCustomAction.reset();
      setShowTimeoutError(true);
      return true;
    },
    onSuccess: (data, variables, context) => {
      setMainResult(data.custom_result);
    },
  });








  useEffect(() => {
    if (!!mainResult) {
      if (!!perAge) {
        // age focused line chart data
        let mnths:string[] = [];
        let temp_afld:any[] = [];
        let temp_afld_sold:any[] = [];
        let temp_afbd:any[] = [];
        // @ts-ignore
        mainResult.forEach(mnd => {
          let mnd_key = DateTime.fromFormat(mnd.som, "dd/LL/y").toFormat("LL/y");
          if (statMode === 'quarter') mnd_key = mnd.som;
          if (statMode === 'year') mnd_key = mnd.som;
          mnths.push(mnd_key);

          let temp_afbd_set = {
            name: mnd_key
          };
          Array.from(Array(120), (_, i) => i).map((_, age) => {
            let grp_key_b = [age, "R"].join("-");
            let grp_key_s = [age, "T"].join("-");

            // @ts-ignore
            temp_afbd_set[grp_key_b] = (!!mnd?.ages && !!mnd?.ages[age]?.bought?.amount) ? mnd?.ages[age]?.bought?.amount : 0;
            // @ts-ignore
            temp_afbd_set[grp_key_s] = (!!mnd?.ages && !!mnd?.ages[age]?.sold?.amount) ? mnd?.ages[age]?.sold?.amount : 0;
          });
          if (hiddenDataPoints.indexOf(mnd_key) < 0) temp_afbd.push(temp_afbd_set);
        });
  
        Array.from(Array(120), (_, i) => i).map((_, age) => {
          let temp_afld_set = temp_afld[age];
          if (!temp_afld_set) temp_afld_set = {
            name: `${age} yr`
          };
          mnths.forEach(k => {temp_afld_set[k] = 0});
          temp_afld[age] = temp_afld_set;

          let temp_afld_sold_set = temp_afld_sold[age];
          if (!temp_afld_sold_set) temp_afld_sold_set = {
            name: `${age} yr`
          };
          mnths.forEach(k => {temp_afld_sold_set[k] = 0});
          temp_afld_sold[age] = temp_afld_sold_set;
        })
  
        // @ts-ignore
        mainResult.forEach(mnd => {
          let mnd_key = DateTime.fromFormat(mnd.som, "dd/LL/y").toFormat("LL/y");
          if (statMode === 'quarter') mnd_key = mnd.som;
          if (statMode === 'year') mnd_key = mnd.som;
          // @ts-ignore
          mnd.ages.forEach((mnd_age, kkk) => {
            if (!!mnd_age?.bought?.users) temp_afld[kkk][mnd_key] = mnd_age.bought.users;
            if (!!mnd_age?.sold?.users) temp_afld_sold[kkk][mnd_key] = mnd_age.sold.users;
          });
        });
  
        // console.log(mnths);
        // console.log(temp_afld);
        // console.log(temp_afld_sold);
        console.log(temp_afbd);
        setAgeFocusedLineData(temp_afld);
        setAgeFocusedLineDataSold(temp_afld_sold);
        setAmountFocusedBarData(temp_afbd);
      }

// ==================================================

      if (!perAge) {
        // age focused line chart data
        let mnths:string[] = [];
        let temp_afld:any[] = [];
        let temp_afld_sold:any[] = [];
        let temp_afbd:any[] = [];
        // @ts-ignore
        mainResult.forEach(mnd => {
          let mnd_key = DateTime.fromFormat(mnd.som, "dd/LL/y").toFormat("LL/y");
          if (statMode === 'quarter') mnd_key = mnd.som;
          if (statMode === 'year') mnd_key = mnd.som;
          mnths.push(mnd_key);

          let temp_afbd_set = {
            name: mnd_key
          };
          ageGroups.map(grp => {
            let grp_key = [grp[0], grp[1]].join("-");
            let grp_key_b = [grp[0], grp[1], "R"].join("-");
            let grp_key_s = [grp[0], grp[1], "T"].join("-");

            // @ts-ignore
            temp_afbd_set[grp_key_b] = (!!mnd?.groups && !!mnd?.groups[grp_key]?.bought?.amount) ? mnd?.groups[grp_key]?.bought?.amount : 0;
            // @ts-ignore
            temp_afbd_set[grp_key_s] = (!!mnd?.groups && !!mnd?.groups[grp_key]?.sold?.amount) ? mnd?.groups[grp_key]?.sold?.amount : 0;
          });
          if (hiddenDataPoints.indexOf(mnd_key) < 0) temp_afbd.push(temp_afbd_set);
        });
  
        ageGroups.map(grp => {
          let grp_key = [grp[0], grp[1]].join("-");

          let temp_afld_set = {
            name: `${grp_key}`
          };
          let temp_afld_sold_set = {
            name: `${grp_key}`
          };
          // @ts-ignore
          mainResult.forEach(mnd => {
            let mnd_key = DateTime.fromFormat(mnd.som, "dd/LL/y").toFormat("LL/y");
            if (statMode === 'quarter') mnd_key = mnd.som;
            if (statMode === 'year') mnd_key = mnd.som;
            // @ts-ignore
            if (!!mnd?.groups && mnd?.groups[grp_key]?.bought?.users) {
              // @ts-ignore
              temp_afld_set[mnd_key] = mnd?.groups[grp_key]?.bought?.users;
            } else {
              // @ts-ignore
              temp_afld_set[mnd_key] = 0;
            }
            if (!!mnd?.groups && mnd?.groups[grp_key]?.sold?.users) {
              // @ts-ignore
              temp_afld_sold_set[mnd_key] = mnd?.groups[grp_key]?.sold?.users;
            } else {
              // @ts-ignore
              temp_afld_sold_set[mnd_key] = 0;
            }
          });
          temp_afld.push(temp_afld_set);
          temp_afld_sold.push(temp_afld_sold_set);
        });
  
        // console.log(mnths);
        // console.log(temp_afld);
        // console.log(temp_afld_sold);
        // console.log(temp_afbd);
        setAgeFocusedLineData(temp_afld);
        setAgeFocusedLineDataSold(temp_afld_sold);
        setAmountFocusedBarData(temp_afbd);
      }
    }
  }, [mainResult, perAge, hiddenDataPoints]);











  return <Page sx={{}} title="Operation // Transfers" helper="operations">
    <Grid container spacing="8" sx={{
      "& .bar_T": {
        // opacity: 0.6
      }
    }}>
      <Grid item xs={12}>
        <Typography variant="caption">Data interval</Typography>
      </Grid>
      <Grid item xs={12}>
        <ButtonGroup variant="outlined">
          <Btn variant={statMode === "month" ? "contained" : "outlined"} onClick={() => {setStatMode("month");}}>Monthly</Btn>
          <Btn variant={statMode === "quarter" ? "contained" : "outlined"} onClick={() => {setStatMode("quarter");}}>Quarterly</Btn>
          <Btn variant={statMode === "year" ? "contained" : "outlined"} onClick={() => {setStatMode("year");}}>Yearly</Btn>
        </ButtonGroup>
      </Grid>
      <Grid item container xs={12} spacing="8">
        <Grid item xs={12}>
          <Typography variant="caption">Age groups</Typography>
        </Grid>
        {ageGroups.map((age, i) => <Grid item container xs={2} spacing="8">
          <Grid item xs={5}>
            <StyledTextField
              label="Start ["
              value={age[0].toString()}
              id='start_x'
              onChange={(v) => {
                let newAgeGroups = [...ageGroups];
                newAgeGroups[i][0] = parseInt(v, 10);
                setAgeGroups(newAgeGroups);
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={5} sx={{position: 'relative'}}>
            <StyledTextField
              label="End ]"
              value={age[1].toString()}
              id='end_x'
              onChange={(v) => {
                let newAgeGroups = [...ageGroups];
                newAgeGroups[i][1] = parseInt(v, 10);
                setAgeGroups(newAgeGroups);
              }}
              fullWidth
            />
            <RemoveCircleIcon sx={{color: theme.palette.secondary.main, position: 'absolute', top: 0, right: -16, cursor: 'pointer'}} onClick={() => {
              let newAgeGroups: [number, number][] = [];
              ageGroups.forEach((ag, ii) => {
                if (ii !== i) newAgeGroups.push(ag);
              });
              setAgeGroups(newAgeGroups);
            }} />
          </Grid>
        </Grid>)}
        <Grid item xs={2} container spacing="8">
          <Grid item xs={10} sx={{textAlign: 'center'}}>
            <AddCircleOutlineIcon sx={{color: theme.palette.tertiary?.main, marginTop: 1.5, cursor: 'pointer'}} onClick={() => {
              setAgeGroups([...ageGroups, [0, 0]]);
            }} />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{marginTop: 2}}>
        <StyledButton
          label="Fetch"
          id='fetch'
          contained
          loading={mutationCustomAction.isPending}
          onClick={(v) => {
            setShowTimeoutError(false);
            mutationCustomAction.mutate({
              formData: {
                object: 'operations',
                class_action: 'custom_api_operations_transfers',
                stat_mode: statMode,
                age_groups: ageGroups,
                per_age: (perAge ? 1 : 0)
              }
            });
          }}
          sx={{
            marginRight: 1
          }}
        />
      </Grid>
      {!!showTimeoutError && <Grid item xs={12}>
        <Typography sx={{
          padding: 2,
          border: '1px solid transparent',
          borderColor: theme.palette.secondary.main,
          backgroundColor: theme.palette.opacitated?.secondary_02
        }}>A timeout happened. If it took about a minute for this message to show, the cache is building. Try again in 2-3 minutes.<br />If this did not take about a minute, contact IT!</Typography>
      </Grid>}




      {!!mainResult && <>
        <Grid item xs={12}><Divider /></Grid>
        <Grid item xs={4}>
          <Typography variant="caption">Data visualisation</Typography><br/>
          <ButtonGroup variant="outlined">
            <Btn variant={!!showRawData ? "contained" : "outlined"} onClick={() => {setShowRawData(true);}}>Raw data</Btn>
            <Btn variant={!showRawData ? "contained" : "outlined"} onClick={() => {setShowRawData(false);}}>Graphs</Btn>
          </ButtonGroup>
        </Grid>

        {!showRawData && <>
          <Grid item xs={4}>
            <Typography variant="caption">Age split</Typography><br/>
            <ButtonGroup variant="outlined">
              <Btn variant={!!perAge ? "contained" : "outlined"} onClick={() => {setPerAge(!perAge);}}>Per Age</Btn>
              <Btn variant={!perAge ? "contained" : "outlined"} onClick={() => {setPerAge(!perAge);}}>Age Groups</Btn>
            </ButtonGroup>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="caption">Graph focus</Typography><br/>
            <ButtonGroup variant="outlined">
              <Btn variant={graphFocus === 'age' ? "contained" : "outlined"} onClick={() => {setGraphFocus('age');}}>Age</Btn>
              <Btn variant={graphFocus === 'amount' ? "contained" : "outlined"} onClick={() => {setGraphFocus('amount');}}>Amount</Btn>
            </ButtonGroup>
          </Grid>
          {statMode === 'month' && !!ageFocusedLineData && <Grid item xs={12} sx={{marginBottom: 3}}>
            <Typography variant="caption">Active months</Typography><br/>
            <ButtonGroup variant="outlined" size="small">
              {Object.keys(ageFocusedLineData[0] || {}).filter(fff => fff !== 'name').map((kk, ii) => <Btn variant={hiddenDataPoints.indexOf(kk) < 0 ? "contained" : "outlined"} onClick={() => {
                if (hiddenDataPoints.indexOf(kk) < 0) {
                  setHiddenDataPoints([...hiddenDataPoints, kk]);
                } else {
                  setHiddenDataPoints(hiddenDataPoints.filter(fff => fff !== kk));
                }
              }}>{kk}</Btn>)}
            </ButtonGroup>
          </Grid>}
          {statMode === 'quarter' && !!ageFocusedLineData && <Grid item xs={12} sx={{marginBottom: 3}}>
            <Typography variant="caption">Active quarters</Typography><br/>
            <ButtonGroup variant="outlined" size="small">
              {Object.keys(ageFocusedLineData[0] || {}).filter(fff => fff !== 'name').map((kk, ii) => <Btn variant={hiddenDataPoints.indexOf(kk) < 0 ? "contained" : "outlined"} onClick={() => {
                if (hiddenDataPoints.indexOf(kk) < 0) {
                  setHiddenDataPoints([...hiddenDataPoints, kk]);
                } else {
                  setHiddenDataPoints(hiddenDataPoints.filter(fff => fff !== kk));
                }
              }}>{kk}</Btn>)}
            </ButtonGroup>
          </Grid>}
          {statMode === 'year' && !!ageFocusedLineData && <Grid item xs={12} sx={{marginBottom: 3}}>
            <Typography variant="caption">Active years</Typography><br/>
            <ButtonGroup variant="outlined" size="small">
              {Object.keys(ageFocusedLineData[0] || {}).filter(fff => fff !== 'name').map((kk, ii) => <Btn variant={hiddenDataPoints.indexOf(kk) < 0 ? "contained" : "outlined"} onClick={() => {
                if (hiddenDataPoints.indexOf(kk) < 0) {
                  setHiddenDataPoints([...hiddenDataPoints, kk]);
                } else {
                  setHiddenDataPoints(hiddenDataPoints.filter(fff => fff !== kk));
                }
              }}>{kk}</Btn>)}
            </ButtonGroup>
          </Grid>}
          {graphFocus === 'age' && !!ageFocusedLineData && <>
            <Typography variant="h4">Incoming transfers</Typography><br/>
            <LineChart width={1000} height={600} data={ageFocusedLineData}>
              <CartesianGrid strokeDasharray="5 5" />
              <XAxis dataKey="name" interval={!!perAge ? 4 : 0} angle={-25} textAnchor="end" height={150} />
              <YAxis allowDecimals={false} />
              <Tooltip />
              {Object.keys(ageFocusedLineData[0] || {}).filter(fff => fff !== 'name').map((kk, ii) => <Line
                type="monotone"
                dataKey={kk}
                stroke={statMode === 'year' ? colors6[ii] : colors14[ii]}
                activeDot={{ r: 8 }}
                hide={hiddenDataPoints.indexOf(kk) > -1}
              />)}
            </LineChart>
          </>}
          {graphFocus === 'age' && !!ageFocusedLineDataSold && <>
            <Typography variant="h4">Outgoing transfers</Typography><br/>
            <LineChart width={1000} height={600} data={ageFocusedLineDataSold}>
              <CartesianGrid strokeDasharray="5 5" />
              <XAxis dataKey="name" interval={!!perAge ? 4 : 0} angle={-25} textAnchor="end" height={150} />
              <YAxis allowDecimals={false} />
              <Tooltip />
              {Object.keys(ageFocusedLineDataSold[0] || {}).filter(fff => fff !== 'name').map((kk, ii) => <Line
                type="monotone"
                dataKey={kk}
                stroke={statMode === 'year' ? colors6[ii] :colors14[ii]}
                activeDot={{ r: 8 }}
                hide={hiddenDataPoints.indexOf(kk) > -1}
              />)}
            </LineChart>
          </>}
          {graphFocus === 'amount' && <>
            <BarChart width={1000} height={600} data={amountFocusedBarData}>
              <CartesianGrid strokeDasharray="5 5" />
              <XAxis dataKey="name" angle={-25} textAnchor="end" height={150} />
              <YAxis allowDecimals={false} />
              {!perAge && <Tooltip />}
              {Object.keys(amountFocusedBarData[0] || {}).filter(fff => fff !== 'name').map((kk, ii) => <Bar
                dataKey={kk}
                fill={(!!perAge ? colors120 : colors12)[parseInt((ii/2).toString(), 10)]}
                stackId={kk.split("").reverse()[0]}
                className={`bar_${kk.split("").reverse()[0]}`}
              />)}
            </BarChart>
          </>}
        </>}












        {!!showRawData && <>
          {!!perAge && <>
            <Grid item xs={12}><Typography sx={{fontWeight: 'bold', textDecoration: 'underline', textAlign: 'center'}}>
              <ChevronLeft onClick={() => {
                if (activeIteration > 0) setActiveIteration(activeIteration - 1);
              }} sx={{
                marginRight: 1,
                marginBottom: -1,
                cursor: 'pointer'
              }} />
              {mainResult[activeIteration].som}
              <ChevronRight onClick={() => {
                if (activeIteration < (mainResult.length - 1)) setActiveIteration(activeIteration + 1);
              }} sx={{
                marginLeft: 1,
                marginBottom: -1,
                cursor: 'pointer'
              }} />
            </Typography></Grid>

            <Grid item xs={1}></Grid>
            <Grid item xs={5} sx={{textAlign: 'center'}}><Typography sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Bought</Typography></Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} sx={{textAlign: 'center'}}><Typography sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Sold</Typography></Grid>

            <Grid item xs={1} sx={{borderBottom: '1px solid lightgrey', borderRight: '1px solid lightgrey'}}></Grid>
            <Grid item xs={2} sx={{textAlign: 'right', borderBottom: '1px solid lightgrey'}}><Typography sx={{fontWeight: 'bold'}}>Users</Typography></Grid>
            <Grid item xs={3} sx={{textAlign: 'right', borderBottom: '1px solid lightgrey'}}><Typography sx={{fontWeight: 'bold'}}>Amount</Typography></Grid>
            <Grid item xs={1} sx={{borderBottom: '1px solid lightgrey', borderRight: '1px solid lightgrey'}}></Grid>
            <Grid item xs={2} sx={{textAlign: 'right', borderBottom: '1px solid lightgrey'}}><Typography sx={{fontWeight: 'bold'}}>Users</Typography></Grid>
            <Grid item xs={3} sx={{textAlign: 'right', borderBottom: '1px solid lightgrey'}}><Typography sx={{fontWeight: 'bold'}}>Amount</Typography></Grid>
            
            {Array.from(Array(120), (_, i) => i).map((_, age) => <>
              {(mainResult[activeIteration].ages[age]?.bought.users > 0 || mainResult[activeIteration].ages[age]?.sold.users > 0) && <>
                <Grid item xs={1} sx={{borderRight: '1px solid lightgrey'}}>
                  <Typography>{age} yr</Typography>
                </Grid>
                <Grid item xs={2} sx={{textAlign: 'right'}}>
                  {mainResult[activeIteration].ages[age]?.bought.users > 0 && <Typography>{mainResult[activeIteration].ages[age]?.bought.users}</Typography>}
                </Grid>
                <Grid item xs={3} sx={{textAlign: 'right'}}>
                  {mainResult[activeIteration].ages[age]?.bought.users > 0 && <Typography>{mainResult[activeIteration].ages[age]?.bought.amount.toLocaleString("nl-BE", {style: "currency", currency: "EUR", maximumFractionDigits: 0})}</Typography>}
                </Grid>
                <Grid item xs={1} sx={{borderRight: '1px solid lightgrey'}}></Grid>
                <Grid item xs={2} sx={{textAlign: 'right'}}>
                  {mainResult[activeIteration].ages[age]?.sold.users > 0 && <Typography>{mainResult[activeIteration].ages[age]?.sold.users}</Typography>}
                </Grid>
                <Grid item xs={3} sx={{textAlign: 'right'}}>
                  {mainResult[activeIteration].ages[age]?.sold.users > 0 && <Typography>{mainResult[activeIteration].ages[age]?.sold.amount.toLocaleString("nl-BE", {style: "currency", currency: "EUR", maximumFractionDigits: 0})}</Typography>}
                </Grid>
              </>}
            </>)}
          </>}
          {!perAge && <>
            <Grid item xs={12}><Typography sx={{fontWeight: 'bold', textDecoration: 'underline', textAlign: 'center'}}>
              <ChevronLeft onClick={() => {
                if (activeIteration > 0) setActiveIteration(activeIteration - 1);
              }} sx={{
                marginRight: 1,
                marginBottom: -1,
                cursor: 'pointer'
              }} />
              {mainResult[activeIteration].som}
              <ChevronRight onClick={() => {
                if (activeIteration < (mainResult.length - 1)) setActiveIteration(activeIteration + 1);
              }} sx={{
                marginLeft: 1,
                marginBottom: -1,
                cursor: 'pointer'
              }} />
            </Typography></Grid>

            <Grid item xs={1}></Grid>
            <Grid item xs={5} sx={{textAlign: 'center'}}><Typography sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Bought</Typography></Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5} sx={{textAlign: 'center'}}><Typography sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Sold</Typography></Grid>

            <Grid item xs={1} sx={{borderBottom: '1px solid lightgrey', borderRight: '1px solid lightgrey'}}></Grid>
            <Grid item xs={2} sx={{textAlign: 'right', borderBottom: '1px solid lightgrey'}}><Typography sx={{fontWeight: 'bold'}}>Users</Typography></Grid>
            <Grid item xs={3} sx={{textAlign: 'right', borderBottom: '1px solid lightgrey'}}><Typography sx={{fontWeight: 'bold'}}>Amount</Typography></Grid>
            <Grid item xs={1} sx={{borderBottom: '1px solid lightgrey', borderRight: '1px solid lightgrey'}}></Grid>
            <Grid item xs={2} sx={{textAlign: 'right', borderBottom: '1px solid lightgrey'}}><Typography sx={{fontWeight: 'bold'}}>Users</Typography></Grid>
            <Grid item xs={3} sx={{textAlign: 'right', borderBottom: '1px solid lightgrey'}}><Typography sx={{fontWeight: 'bold'}}>Amount</Typography></Grid>
            
            {ageGroups.map(grp => <>
              <Grid item xs={1} sx={{borderRight: '1px solid lightgrey'}}>
                <Typography>{grp[0]}-{grp[1]}</Typography>
              </Grid>
              <Grid item xs={2} sx={{textAlign: 'right'}}>
                <Typography>{mainResult[activeIteration].groups[`${grp[0]}-${grp[1]}`].bought.users}</Typography>
              </Grid>
              <Grid item xs={3} sx={{textAlign: 'right'}}>
                <Typography>{mainResult[activeIteration].groups[`${grp[0]}-${grp[1]}`].bought.amount.toLocaleString("nl-BE", {style: "currency", currency: "EUR", maximumFractionDigits: 0})}</Typography>
              </Grid>
              <Grid item xs={1} sx={{borderRight: '1px solid lightgrey'}}></Grid>
              <Grid item xs={2} sx={{textAlign: 'right'}}>
                <Typography>{mainResult[activeIteration].groups[`${grp[0]}-${grp[1]}`].sold.users}</Typography>
              </Grid>
              <Grid item xs={3} sx={{textAlign: 'right'}}>
                <Typography>{mainResult[activeIteration].groups[`${grp[0]}-${grp[1]}`].sold.amount.toLocaleString("nl-BE", {style: "currency", currency: "EUR", maximumFractionDigits: 0})}</Typography>
              </Grid>
            </>)}
          </>}
        </>}
      </>}
    </Grid>
  </Page>;
}
